import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSocket } from '../contexts/SocketContext';
import { useToast } from '../hooks/useToast';

const MatchFound = ({ sessionId }) => {
  const navigate = useNavigate();
  const { socket } = useSocket();
  const { showToast } = useToast();

  const handleAccept = () => {
    socket.emit('accept-match', { sessionId });
    navigate(`/chat/${sessionId}`);
  };

  const handleDecline = () => {
    socket.emit('decline-match', { sessionId });
    navigate('/');
    showToast('Match declined', 'info');
  };

  return (
    <div className="match-found">
      <h2>Match Found!</h2>
      <p>Someone wants to chat with you.</p>
      <div className="match-actions">
        <button className="accept-button" onClick={handleAccept}>
          Accept
        </button>
        <button className="decline-button" onClick={handleDecline}>
          Decline
        </button>
      </div>
    </div>
  );
};

export default MatchFound; 